import { initialize } from "launchdarkly-js-client-sdk";
import { mapValues } from "lodash";

import type {
  LDFlagValue,
  LDClient,
  LDFlagSet
} from "launchdarkly-js-client-sdk";

// We're sending a context object when initializing an LD instance
// Contexts are resources that encounter our FFs
// Each context has a context kind (ie user, organization, device)
// As of now, we're only leveraging the user context within AP, but we could combine different context instances (multi-context) if needed in the future
// https://docs.launchdarkly.com/home/contexts

let ldClient: LDClient;

export const init = async ({ key, context }) => {
  ldClient = initialize(key, context, {
    fetchGoals: false,
    streaming: true,
    sendEventsOnlyForVariation: true
  });
  return ldClient.waitForInitialization().then(ldClient.allFlags);
};

export const listen = (cb: (flags: LDFlagSet) => void) => {
  if (ldClient) {
    ldClient.on("change", changes => {
      cb(mapValues(changes, change => change.current));
    });
  }
};

export const trackOnce = (flag: LDFlagValue) => {
  if (ldClient) {
    // Call this just for LD event tracking purposes;
    // we don't need to know what the result is because
    // we already stored the result in redux, we just
    // want to tell LD that this flag is being used.
    ldClient.variation(flag, false);
  }
};

export const trackExperimentView = trackOnce;

// This triggers a conversion metric in launch darkly
// Numeric values are currently disabled until we can get all the launch darkly SDKs up to newer versions
export const trackExperiment = ({ eventName, numericValue }) => {
  if (ldClient) {
    if (numericValue) {
      ldClient.track(eventName, null, numericValue);
    } else ldClient.track(eventName);
  }
};
